export function matchesTag(node, tagName) {
    return typeof node !== 'string' && node.tagName === tagName;
}

//# sourceMappingURL=manifest-utils.js.map